/**
 * Component for the account management, used in the Billing page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright (c) Ircam Amplify 2025
 */

import CircularProgress from '@mui/material/CircularProgress'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import './AccountManagement.css'
import './billing.css'

interface AccountManagementProps {
  className?: string
  cancelPlan: any
  updatePayment?: () => Promise<void> | undefined
  cancelAccountPlan: () => Promise<void>
}

const AccountManagement = (props: AccountManagementProps) => {
  const fullClassName = `${props.className} account-management`

  const AccountLink = ({
    msg,
    linkHandler,
  }: {
    msg: string
    linkHandler: any
  }) => {
    const [isLinkProcessing, setLinkProcessing] = useState(false)

    return (
      <Link
        to="#"
        onClick={async (e) => {
          e.preventDefault()
          setLinkProcessing(true)
          try {
            await linkHandler()
          } finally {
            setLinkProcessing(false)
          }
        }}
      >
        <span className="link">
          {msg}
          {isLinkProcessing ? (
            <CircularProgress size="16px" sx={{ color: 'inherit' }} />
          ) : (
            <img className="go-button" src="/icon/CaretRight.svg" />
          )}
        </span>
      </Link>
    )
  }

  return (
    <div className={fullClassName}>
      <div className="billing-component-title">Account management</div>
      <div className="link-container">
        {props.updatePayment && (
          <AccountLink
            msg="Update payment info"
            linkHandler={props.updatePayment}
          />
        )}
        <AccountLink msg="Cancel plan" linkHandler={props.cancelAccountPlan} />
      </div>
    </div>
  )
}

export default AccountManagement
